import site from '../../site';

const getSiteLocales = (state) => {
  const pages = site.selectors.getPages(state);

  if (!pages) return [];

  return [...new Set(pages.map((page) => page.locale))];
};

export default getSiteLocales;
